import React, { useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';
import Sidebar from '../../components/Sidebar';
import './TransactionReport.css';
import autoTable from 'jspdf-autotable';
import NoData from '../../components/NoData';
import { gql, useQuery } from "@apollo/client";


import * as FaIcons from "react-icons/fa"; // or "react-icons/fa" depending on version

const FaFileExcel = FaIcons.FaFileExcel as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaFileCsv   = FaIcons.FaFileCsv   as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaFilePdf   = FaIcons.FaFilePdf   as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaChartBar = FaIcons.FaChartBar as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


// interface Transaction {
//   id: string;
//   userId: string;
//   amount: number;
//   date: string;
//   method: string;
//   status: string;
// }
interface Transaction {
  id: string;
  userId: string;
  type: string;
  amount: number;
  reference: string;
  createdAt: string;
}

// const dummyTransactions: Transaction[] = [
//   {
//     id: 'txn001',
//     userId: 'user001',
//     amount: 150.75,
//     date: '2025-07-29T10:30:00Z',
//     method: 'Credit Card',
//     status: 'Completed',
//   },
//   {
//     id: 'txn002',
//     userId: 'user002',
//     amount: 75.0,
//     date: '2025-07-28T14:45:00Z',
//     method: 'UPI',
//     status: 'Pending',
//   },
//   {
//     id: 'txn003',
//     userId: 'user003',
//     amount: 200.0,
//     date: '2025-07-30T09:15:00Z',
//     method: 'PayPal',
//     status: 'Completed',
//   },
//   {
//     id: 'txn004',
//     userId: 'user004',
//     amount: 89.99,
//     date: '2025-07-27T16:20:00Z',
//     method: 'Credit Card',
//     status: 'Failed',
//   },
//   {
//     id: 'txn005',
//     userId: 'user005',
//     amount: 45.5,
//     date: '2025-07-31T11:45:00Z',
//     method: 'Debit Card',
//     status: 'Completed',
//   },
// ];

const GET_ALL_TRANSACTIONS = gql`
  query GetAllTransactions {
    getAllTransactions {
      id
      userId
      type
      amount
      reference
      createdAt
    }
  }
`;

const TransactionReport: React.FC = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchText, setSearchText] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const { loading, error, data } = useQuery(GET_ALL_TRANSACTIONS);

useEffect(() => {
  if (data?.getAllTransactions) {
    setTransactions(data.getAllTransactions);
  }
}, [data]);

  const filteredData = useMemo(() => {
    const lowerSearch = searchText.toLowerCase();
    return transactions.filter((txn) => {
    const txnDate = new Date(txn.createdAt);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

      // Adjust end date to include the entire day
      if (end) end.setHours(23, 59, 59, 999);

      const matchDate =
        (!start || txnDate >= start) && (!end || txnDate <= end);
      const matchSearch =
        txn.id.toLowerCase().includes(lowerSearch) ||
        txn.userId.toLowerCase().includes(lowerSearch) ||
        txn.type.toLowerCase().includes(lowerSearch) ||
txn.reference.toLowerCase().includes(lowerSearch);

      return matchDate && matchSearch;
    });
  }, [transactions, startDate, endDate, searchText]);

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Transactions');
    XLSX.writeFile(wb, 'transactions_report.xlsx');
  };

  const exportToCSV = () => {
    const csv = XLSX.utils.sheet_to_csv(
      XLSX.utils.json_to_sheet(filteredData)
    );
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, 'transactions_report.csv');
  };

 const exportToPDF = () => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Transaction Report', 14, 16);
  doc.setFontSize(12);
  doc.setTextColor(100);

  let dateRange = '';
  if (startDate || endDate) {
    dateRange = `Date Range: ${startDate || 'Beginning'} to ${endDate || 'Today'}`;
    doc.text(dateRange, 14, 24);
  }

  const tableData = filteredData.map((txn) => [
    txn.id,
txn.userId,
`₹${txn.amount.toFixed(2)}`,
new Date(txn.createdAt).toLocaleDateString(),
txn.type,
txn.reference,
  ]);

  autoTable(doc, {
head: [['ID', 'User', 'Amount', 'Date', 'Type', 'Reference']],
    body: tableData,
    startY: dateRange ? 30 : 20,
    theme: 'grid',
    headStyles: {
      fillColor: [255, 87, 34],
      textColor: 255,
      fontStyle: 'bold'
    },
    styles: {
      cellPadding: 3,
      fontSize: 10,
      valign: 'middle'
    },
  });

  doc.save('transactions_report.pdf');
};

  const clearFilters = () => {
    setStartDate('');
    setEndDate('');
    setSearchText('');
  };

  const columns = [
  {
    name: 'Transaction ID',
    selector: (row: Transaction) => row.id,
    sortable: true,
    width: '220px',
  },
  {
    name: 'User ID',
    selector: (row: Transaction) => row.userId,
    sortable: true,
    width: '180px',
  },
  {
    name: 'Type',
    selector: (row: Transaction) => row.type,
    sortable: true,
    width: '140px',
  },
  {
    name: 'Amount',
    selector: (row: Transaction) => `₹${row.amount.toFixed(2)}`,
    sortable: true,
    width: '130px',
  },
  {
    name: 'Reference',
    selector: (row: Transaction) => row.reference,
    sortable: true,
    width: '180px',
  },
  {
    name: 'Created At',
    selector: (row: Transaction) =>
      new Date(row.createdAt).toLocaleString(),
    sortable: true,
    width: '220px',
  },
];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#FFFCFB' }}>
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div
        style={{
          flex: 1,
          marginLeft: isSidebarOpen ? '250px' : '60px',
          transition: 'margin-left 0.3s ease',
          padding: '30px 40px',
        }}
      >
        <div className="transaction_uid_container">
          <div className="txn_uid_header">
          <h1 className="txn_uid_title">
            <FaChartBar className="txn_uid_icon" /> Transaction Report
          </h1>            
            <div className="txn_uid_summary">
              <div className="txn_uid_card">
                <div className="txn_uid_value">{filteredData.length}</div>
                <div className="txn_uid_label">Total Transactions</div>
              </div>
              <div className="txn_uid_card">
                <div className="txn_uid_value">
                  ₹{filteredData.reduce((sum, txn) => sum + txn.amount, 0).toFixed(2)}
                </div>
                <div className="txn_uid_label">Total Amount</div>
              </div>
              <div className="txn_uid_card">
                <div className="txn_uid_value">
                  {/* {filteredData.filter(txn => txn.status === 'Completed').length} */}
                </div>
                <div className="txn_uid_label">Completed</div>
              </div>
            </div>
          </div>

          <div className="txn_uid_filters">
            <div className="txn_uid_filter_group">
              <div className="txn_uid_date_group">
                <div className="txn_uid_date_input">
                  <label>From:</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="txn_uid_date_picker"
                  />
                </div>
                <div className="txn_uid_date_input">
                  <label>To:</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="txn_uid_date_picker"
                  />
                </div>
                <button 
                  onClick={clearFilters}
                  className="txn_uid_clear"
                >
                  Clear Filters
                </button>
              </div>
            </div>

            <div className="txn_uid_search">
              <input
                type="text"
                placeholder="🔍 Search by ID, user, method, etc."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="txn_uid_search_input"
              />
            </div>

           <div className="txn_uid_export">
            <button onClick={exportToExcel} className="txn_uid_export_btn">
              <FaFileExcel className="txn_uid_icon" /> Excel
            </button>

            <button onClick={exportToCSV} className="txn_uid_export_btn">
              <FaFileCsv className="txn_uid_icon" /> CSV
            </button>

            <button onClick={exportToPDF} className="txn_uid_export_btn">
              <FaFilePdf className="txn_uid_icon" /> PDF
            </button>
          </div>

          </div>

          <div className="txn_uid_table_container">
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[5, 10, 15, 20]}
              highlightOnHover
              striped
              noDataComponent={
                <div className="txn_uid_no_data">
                <NoData message='No matching transactions found'/>
                </div>
              }
              customStyles={{
                headCells: {
                  style: {
                    fontSize: '1.05rem',
                    fontWeight: 700,
                    color: '#FF5722',
                    backgroundColor: '#FFF8F6',
                  },
                },
                rows: {
                  style: {
                    fontSize: '1rem',
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionReport;